import { useState, useEffect, useRef, useCallback } from "react";
import MessengerWidget from "./components/MessengerWidget";
import { Toaster } from "react-hot-toast";
import "./App.css";

function App() {
  const getEmployeeIdFromUrl = () => {
    const path = window.location.pathname;
    const segments = path.split("/").filter((segment) => segment);

    // /mob/:id support
    if (segments[0] === "mob" && segments[1]) {
      return { id: parseInt(segments[1]), isMobile: true };
    }

    return { id: parseInt(segments[segments.length - 1]), isMobile: false };
  };

  const { id: employeeId, isMobile } = getEmployeeIdFromUrl();

  return (
    <>
      <MessengerWidget employeeId={employeeId} mobileMode={isMobile} />
      <Toaster position="bottom-right" />
    </>
  );
}

export default App;
